import OneSignal from 'onesignal-cordova-plugin';
import { Capacitor } from '@capacitor/core';
import { getCurrentPro } from '@/services/auth';
import { VERSION } from '@/constant/version';

export const loginOneSignal = async () => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  const pro = await getCurrentPro();

  OneSignal.login(String(pro.id));

  OneSignal.User.addTags({
    pro_id: String(pro.id),
    role: 'pro',
    city: pro.team?.office_city ?? 'unknown',
    job: pro.profession ?? 'unknown',
    type: pro.type,
    visibility: pro.team?.visibility ?? 'unknown',
    app_version: VERSION,
  });
};

export function logoutOneSignal() {
  if (!Capacitor.isNativePlatform()) return;

  OneSignal.logout();

  OneSignal.User.removeTags(['pro_id', 'role', 'city', 'job', 'type', 'visibility', 'app_version']);
}
